import { useState, useEffect } from "preact/hooks";
import { getQueryString } from "../helpers/getQueryString";
import { isVersionNewer } from "../helpers/isVersionNewer";

export const useMargins = () => {
  const [hasMargins, setHasMargins] = useState(false);

  useEffect(() => {
    const { dnApp, dnAppVersion } = getQueryString(window.location.href);
    const minVersion = "6.0.1";

    if (!!dnApp && dnAppVersion && isVersionNewer(dnAppVersion, minVersion)) {
      setHasMargins(true);
    }
  }, []);

  return { hasMargins };
};
